import { render } from "./TargetCalendar.vue?vue&type=template&id=8573bb86&scoped=true"
import script from "./TargetCalendar.vue?vue&type=script&lang=js"
export * from "./TargetCalendar.vue?vue&type=script&lang=js"

import "./TargetCalendar.vue?vue&type=style&index=0&id=8573bb86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8573bb86"]])

export default __exports__